import { render } from "./Homepage.vue?vue&type=template&id=2f82070e"
import script from "./Homepage.vue?vue&type=script&lang=js"
export * from "./Homepage.vue?vue&type=script&lang=js"

import "./Homepage.vue?vue&type=style&index=0&id=2f82070e&lang=css"
script.render = render

export default script